import HTTP from '@rocketfid/api'

const state = {
  items: []
}

// getters
const getters = {
  advices: (state) => {
    return state.items
  },
  getById: (state) => (id) => {
    return state.items.find(item => (item.id === id))
  }
}

// actions
const actions = {
  loadAdvices ({ commit, dispatch, rootGetters }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .advice.getAll()
      .then((advices) => {
        dispatch('advices/resetAdvices', null, { root: true })
        commit('ADD_ADVICE_ITEMS', { items: advices })
        return advices
      })
  },

  resetAdvices ({ commit }) {
    return new Promise((resolve) => {
      commit('RESET_ADVICE_ITEMS')
      resolve()
    })
  },

  addAdvice ({ commit, rootGetters }, { advice }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .advice.create(advice)
      .then((advice) => {
        commit('ADD_ADVICE_ITEM', { item: advice })
        return advice
      })
  },

  updateAdvice ({ commit, rootGetters }, { advice }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .advice.update(advice)
      .then((advice) => {
        commit('UPDATE_ADVICE_ITEM', { item: advice })
        return advice
      })
  },

  removeAdvice ({ commit, rootGetters }, { advice }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .advice.delete(advice)
      .then((advice) => {
        commit('REMOVE_ADVICE_ITEM', { item: advice })
        return advice
      })
  }
}

// mutations
const mutations = {
  ADD_ADVICE_ITEMS: (state, { items }) => {
    state.items.push(...items)
  },

  RESET_ADVICE_ITEMS: (state) => {
    state.items = []
  },

  ADD_ADVICE_ITEM: (state, { item }) => {
    state.items.push(item)
  },

  UPDATE_ADVICE_ITEM: (state, { item }) => {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        Object.assign(state.items[i], item)
      }
    }
  },
  REMOVE_ADVICE_ITEM: (state, { item }) => {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        return state.items.splice(i, 1)
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/advices.js